import { Box, chakra, Flex, ListItem, OrderedList, UnorderedList } from '@chakra-ui/react';
import { useLanguage } from '../i18n/LanguageContext';
import { GROUP_DETAILS } from '../i18n/translations';
import ReviewWarning from './ReviewWarning';

const ResearchGroupIntro = ({ route }) => {
  const { language, t } = useLanguage();
  const content = GROUP_DETAILS[route][language];
  const List = content.ordered ? OrderedList : UnorderedList;

  return (
    <Flex textAlign="center" pt={10} justifyContent="center" direction="column" width="full">
      <Box width={{ base: 'full', sm: 'lg', lg: 'xl' }} margin="auto">
        <chakra.h3 fontWeight="bold" fontSize={32} color="blue.400">
          {t('common.introduction')}
        </chakra.h3>
        <chakra.h1 py={5} fontSize={40} fontWeight="bold" color="gray.700">
          {content.name}<ReviewWarning message={content.warning} />
        </chakra.h1>
      </Box>
      <Flex
        boxShadow="lg"
        alignItems="center"
        width="100%"
        rounded="xl"
        p={{ base: 6, md: 10 }}
        position="relative"
        bg="white"
        _after={{
          content: '""', position: 'absolute', height: '50px', width: '50px', left: '25px', top: '-20px',
          backgroundSize: 'cover', backgroundImage: "url('/quotation_marks.png')",
        }}
      >
        <Box textAlign="left">
          <Box fontFamily="Inter" fontWeight="medium" fontSize="20px" pb={4}>
            {content.paragraphs.map((paragraph, index) => (
              <chakra.p key={paragraph} mb={index === content.paragraphs.length - 1 ? 2 : 5}>
                {paragraph}
              </chakra.p>
            ))}
            <List spacing={2}>
              {content.items.map((item) => <ListItem key={item}>{item}</ListItem>)}
            </List>
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};

export default ResearchGroupIntro;
